/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const ConnectionViewIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 43 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-1377)">
      <g id="Connection-View" transform="matrix(0.542569,0,0,0.571048,170.006,406.052)">
        <g transform="matrix(0.632127,-2.57388e-16,-1.00628e-16,0.600602,-1524.21,1700.2)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(0.983703,0,0,0.978895,1.46943,37.0407)">
          <g transform="matrix(0.0608649,-9.96661e-18,-5.88001e-05,0.0428489,-61.173,1684.43)">
            <path
              d="M1664.86,608.027L1664.59,608.027L1664.44,459.185L2057.55,459.951L2057.69,608.793L2057.55,608.793L2057.55,1892.75L2487.88,1893.59L2485.1,459.951L2878.22,459.185L2878.37,608.027L2878.1,608.027L2878.98,1237.4L2878.84,1237.38L2878.98,1237.54L2597.84,1732.56L2598.43,2042.64L2488.17,2042.64L2488.17,2042.43L2057.55,2041.59L2057.55,2042.64L1947.29,2042.64L1947.29,1732.56L1665.19,1237.54L1665.33,1237.38L1665.19,1237.4L1664.86,608.027ZM1947.29,608.578L1775.11,608.242L1775.38,1187.25L1947.29,1488.92L1947.29,608.578ZM2597.37,1488.92L2768.7,1187.25L2767.85,608.242L2595.66,608.578L2597.37,1488.92Z"
              style={{ fill: 'white' }}
            />
          </g>
          <g transform="matrix(-0.140644,1.0547e-32,3.05687e-32,0.13363,334.133,1595.7)">
            <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(-0.140644,1.0547e-32,3.05687e-32,0.13363,283.975,1595.7)">
            <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(-0.140644,1.0547e-32,3.05687e-32,0.13363,334.133,1606.65)">
            <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(-0.140644,1.0547e-32,3.05687e-32,0.13363,283.975,1606.65)">
            <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.329088,2.46786e-32,-7.15265e-32,0.312676,-465.951,1458.8)">
            <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'ConnectionViewIcon',
);
